const { checkAllowToSubscribeDeliverySaver } = require('./deliverysaver-handler');

module.exports = function ($stateProvider) {

    const checkIfDeliverySaverComingSoon = ['DeliverySaverService', (deliverySaverService) => {
        deliverySaverService.verifyDeliverySaverIsAvailable();
    }];

    $stateProvider
        .state('shop.deliveryunlimited', {
            url: '/deliveryunlimited',
            resolve: {
                modules: [
                    '$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load('deliverysaver');
                    },
                ],
                navigationItems: ['InspirationService', function (inspirationService) {
                    return inspirationService.getNavigationItems();
                }],
                authMethod: ['ShopperService', shopperService =>
                    (shopperService.getAuthenticationMethod().then(response => response.AuthenticationMethod)),
                ],
            },
            onEnter: checkIfDeliverySaverComingSoon,
            views: {
                'left-panel@shop': {
                    controller: [
                        'navigationItems', function (navigationItems) {
                            this.menuItems = navigationItems;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: '<wow-inspiration-navigation ng-if="!$breakpoints.isInSmallFormat" menu-items="$ctrl.menuItems"></wow-inspiration-navigation>',
                },
                'center-panel@shop': {
                    controller: [
                        '$state', 'Settings', '$location', function ($state, settings, $location) {
                            if (!(settings.deliverySaver && settings.deliverySaver.isEnabled && settings.payment && settings.payment.enableDigitalPay)) {
                                $state.go('shop.deliveryunlimited.comingsoon');
                            } else {
                                $location.path(settings.deliverySaver.discoverPageUrl);
                            }
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: '<wow-delivery-saver-plan-selection></wow-delivery-saver-plan-selection>',
                },
            },
            data: {
                authenticate: true,
                pageMetadata: [
                    'PageMetadataService',
                    function (pageMetadataService) {
                        return pageMetadataService.getMetadata({
                            name: 'Delivery Unlimited | Woolworths',
                        });
                    },
                ],
            },
        })
        .state('shop.deliveryunlimited.landing', {
            url: '/landing',
            onEnter: checkIfDeliverySaverComingSoon,
            views: {
                'center-panel@shop': {
                    template: '<wow-delivery-saver-landing></wow-delivery-saver-landing>',
                },
            },
        })
        .state('shop.deliveryunlimited.comingsoon', {
            url: '/comingsoon',
            onEnter: ['$location', 'Settings', ($location, settings) => {
                if (settings.deliverySaver && settings.deliverySaver.isEnabled &&
                    settings.payment && settings.payment.enableDigitalPay) {
                    $location.path(settings.deliverySaver.discoverPageUrl);
                }
            }],
            views: {
                'center-panel@shop': {
                    template: '<wow-delivery-saver-coming-soon></wow-delivery-saver-coming-soon>',
                },
            },
        })
        .state('shop.deliveryunlimited.planselection', {
            url: '/planselection?personalPlansNotEligible&businessPlansNotEligible&seniorPlansNotEligible',
            onEnter: checkIfDeliverySaverComingSoon,
            views: {
                'center-panel@shop': {
                    template: '<wow-delivery-saver-plan-selection></wow-delivery-saver-plan-selection>',
                },
            },
        })
        .state('shop.deliveryunlimited.paymentsetup', {
            url: '/paymentsetup?subscriberType&planType',
            onEnter: [
                '$state',
                //
                // Must use `$stateParams` instead of `$state.params` because `onEnter` has not
                // entered the "to" state yet, rather between "from" and "to" states; hence
                // `$state.params` is still holding the "from" state params.
                //
                // https://stackoverflow.com/questions/27576560/why-does-timeout-affect-how-stateparams-is-resolved-in-a-ui-bootstrap-modal
                //
                '$stateParams',
                'DeliverySaverService',
                'ShopperService',
                checkAllowToSubscribeDeliverySaver,
            ],
            views: {
                'center-panel@shop': {
                    template: '<wow-delivery-saver-payment-setup></wow-delivery-saver-payment-setup>',
                },
            },
        })
        .state('shop.deliveryunlimited.confirmation', {
            url: '/confirmation?subscriptionId',
            views: {
                'center-panel@shop': {
                    template: '<wow-delivery-saver-confirmation></wow-delivery-saver-confirmation>',
                },
            },
            params: {
                data: {},
            },
        })
        .state('shop.deliveryunlimited.paymentupdate', {
            url: '/paymentupdate',
            views: {
                'center-panel@shop': {
                    template: '<wow-delivery-saver-payment-update></wow-delivery-saver-payment-update>',
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/deliverysaver.js